import NonEditableBlock from './base/non-editable-block';
import openingTag from '@intercom/embercom-composer/lib/computed-properties/ic-block-opening-tag';
import { computed } from '@ember/object';
import { hashWithoutNulls, htmlEscape } from '@intercom/pulse/lib/computed-properties';
import EntityList from '@intercom/embercom-composer/blocks/entities/entity-list';
import { CanvasView } from '@intercom/interblocks.ts';
import $ from 'jquery';
import Em from 'ember';
export default NonEditableBlock.extend({
  allowedEntities: [],
  isMedia: true,
  hasEditor: false,
  type: 'messengerCard',
  text: '',
  uri: '',
  canvas: null,
  messenger_app_id: null,
  escapedUri: htmlEscape('uri'),
  escapedText: htmlEscape('text'),
  openingTag: openingTag(),
  closingTag: '</ic-block>',
  innerHtml: computed('_zeroWidthSpace', '_paragraphInserter', 'cardHtml', function () {
    return `${this._zeroWidthSpace}${this._paragraphInserter}<span contenteditable="false">${this.cardHtml}</span>${this._paragraphInserter}${this._zeroWidthSpace}`;
  }),
  cardHtml: Em.computed('canvas', 'serialized', function () {
    this.get('canvasView').render(this.get('canvas'));
    return `<div class="intercom-interblocks-messenger-card">${this.get('canvasElement.innerHTML')}</div>`;
  }),
  serialized: hashWithoutNulls('type', 'uri', 'text', 'canvas', 'messenger_app_id'),
  init() {
    if (Em.isEmpty(this.get('config'))) {
      throw new Error('Config is required when creating a block');
    }
    this.set('id', `block-${Em.guidFor(this)}`);
    this.set('entities', EntityList.create());
    this.setupCanvasView();
  },
  setupCanvasView() {
    let e = document.createElement('div');
    this.set('canvasElement', e);
    this.set('canvasView', new CanvasView(e, this.getClient()));
  },
  willDestroy() {
    this.set('canvasElement', null);
    this.get('canvasView').destroy();
  },
  getClient() {
    let handleResponse = (response, cb) => {
      let newCanvas = Object.assign({}, this.get('canvas'));
      newCanvas.content = response.content;
      this.set('canvas', newCanvas);
      cb(response.content);
      this.get('uploadManager').doRender();
    };
    return {
      get: (url, cb) => {
        $.get(`/ember${url}?app_id=${this.get('uploadManager.config.appId')}`).then(response => handleResponse(response, cb), e => {
          console.error(e);
        });
      },
      post(url, cb) {
        $.post(`/ember${url}`).then(response => handleResponse(response, cb));
      }
    };
  }
});